import { Banner } from '@components';
import { Box } from '@mui/material';
import type { ReactElement } from 'react';

import { SlabConfig } from '../../utils/SlabConfig';

/**
 * Based on config variables set at our infractructure level,
 * conditionally display a maintenace alert box.
 */
export const MaintenanceNotice = (): ReactElement | null => {
  const { maintenanceNoticeBody, maintenanceNoticeTitle, maintenanceNoticeSeverity } = SlabConfig;

  if (maintenanceNoticeBody === '') {
    return null;
  }

  // The severity is a free-form infrastructure setting, and Banner has no style for an unknown value.
  const severity =
    (['error', 'info', 'success', 'warning'] as const).find(
      (value) => value === maintenanceNoticeSeverity,
    ) ?? 'info';

  return (
    <Box paddingBottom='1em'>
      <Banner severity={severity} title={maintenanceNoticeTitle}>
        {maintenanceNoticeBody}
      </Banner>
    </Box>
  );
};
